import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import ExternalLink from './Svg/ExternalLinkIcon';

import { copyFor } from '../copy/copy';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

const Textarea = styled.textarea`
    height: 70px;
    border-radius: 2px;
    border: solid 1px ${props => (props.touched && props.error ? '#ff245e' : '#f1f1ee')};
    font-family: Averta;
    font-size: 12px;
    line-height: 16px;
    padding: 0.571em;
    color: ${props =>
        props.touched && props.error
            ? '#ff245e'
            : props.textareaColor != null
            ? props.textareaColor
            : '#333'};
    -webkit-appearance: none;
    resize: none;

    @media (max-width: 30em) {
        margin-left: 0;
        margin-right: 0;
    }

    @media (min-width: 30em) {
        &.message-response {
            position: absolute;
            bottom: 72px;
            width: 100%;
            transition: height 0.6s;
        }
    }

    &.petition {
        position: absolute;
        height: 138px;
        bottom: 68px;
        width: 100%;
        background: #fff;
        color: #333;
        opacity: 1;
        transition: height 0.6s;

        @media (max-width: 30em) {
            bottom: 108px;
        }

        &.expanded {
            height: 71% !important;

            @media (max-width: 30em) {
                height: 73% !important;
            }
        }
    }

    &:focus {
        outline: none;
        border: solid 1px #008eff;
    }

    &::placeholder {
        color: #a59f9f;
    }

    @media (max-width: 30em) {
        height: 205px;

        &.message-response {
            &.petition {
                height: 206px;
            }
        }
    }
`;

const LabelContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Error = styled.div`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-align: right;
    color: #ff245e;
    text-transform: uppercase;
`;

const Label = styled.label`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 0.5em;
`;

const ExpandButton = styled.div`
    position: absolute;
    top: 185px;
    right: 25px;
    font-size: 12px;
    color: #fff;
    line-height: 1.2;
    background: #072647;
    border-radius: 3px;
    opacity: 0.5;
    padding: 4px 6px;
    transition: opacity 0.2s, top 0.2s;

    @media (max-width: 30em) {
        top: 310px;
        right: 20px;
    }

    &:hover {
        opacity: 0.6;
        cursor: pointer;
    }

    #exitLabel {
        display: none;
        padding-left: 16px;
    }
`;

const CloseButton = styled.span`
    width: 14px;
    height: 26px;
    transform: rotate(45deg);
    font-family: Averta;
    font-size: 24px;
    line-height: 1.08;
    text-align: left;
    color: #fff;
    top: -2px;
    left: 5px;
    position: absolute;
    cursor: pointer;
    display: inline-block;
`;

const expandTextarea = () => {
    var textarea = document.getElementById('textarea');
    textarea.classList.toggle('expanded');

    var expandButton = document.getElementById('expandButton');
    expandButton.classList.toggle('expanded');

    var expandLabel = document.getElementById('expandLabel');
    var exitLabel = document.getElementById('exitLabel');
    expandLabel.style.display = expandLabel.style.display === 'none' ? 'block' : 'none';
    exitLabel.style.display = exitLabel.style.display === 'block' ? 'none' : 'block';

    document.querySelectorAll('.row-wrapper-1')[0].classList.toggle('focused');
    document.querySelectorAll('.row-wrapper-2')[0].classList.toggle('focused');
};

class TextareaGroup extends React.Component {
    render() {
        return (
            <Container>
                <LabelContainer className={this.props.classLabel} id="labelResponse">
                    <Label htmlFor="">{this.props.label}</Label>
                    {this.props.meta.touched && this.props.meta.error && (
                        <Error>{this.props.meta.error}</Error>
                    )}
                </LabelContainer>
                <Textarea
                    {...this.props.input}
                    {...this.props.meta}
                    textareaColor={this.props.textareaColor}
                    maxLength={this.props.maxLength}
                    placeholder={this.props.placeholder}
                    autocomplete={this.props.autocomplete}
                    name={this.props.title}
                    onFocus={this.props.onFocus}
                    id="textarea"
                    className={this.props.class}
                    readOnly={this.props.readOnly}
                />
                {this.props.expandButton && (
                    <ExpandButton onClick={expandTextarea} id="expandButton">
                        <span id="expandLabel">
                            <ExternalLink /> {copyFor('expandableTextArea', 'expand')}
                        </span>
                        <span id="exitLabel">
                            <CloseButton>+</CloseButton>
                            {copyFor('expandableTextArea', 'exit')}
                        </span>
                    </ExpandButton>
                )}
            </Container>
        );
    }
}

TextareaGroup.propTypes = {
    label: PropTypes.string.isRequired,
    meta: PropTypes.object.isRequired,
    primary: PropTypes.bool,
    autoFocus: PropTypes.bool,
    maxLength: PropTypes.number,
    autoFocusTimeout: PropTypes.number,
    placeholder: PropTypes.string,
    autocomplete: PropTypes.string,
    title: PropTypes.string,
    class: PropTypes.string,
    classLabel: PropTypes.string,
    textareaColor: PropTypes.string,
    onFocus: PropTypes.func,
    readOnly: PropTypes.bool,
    expandButton: PropTypes.bool
};

export default TextareaGroup;



// WEBPACK FOOTER //
// ./src/components/TextareaGroup.jsx